import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-segundo-separador',
  templateUrl: './segundo-separador.component.html',
  styleUrls: ['./segundo-separador.component.css']
})
export class SegundoSeparadorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
